import { Component, OnInit } from '@angular/core';
import { SportService } from 'src/app/sports/sport.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorage } from '@ngx-pwa/local-storage';

@Component({
    selector: 'app-summary-sport-list',
    templateUrl: './summary-sport-list.component.html',
    styleUrls: ['./summary-sport-list.component.scss']
})
export class SummarySportListComponent implements OnInit {
    public sports: any = null;

    constructor(
        private sportService: SportService,
        private spinner: NgxSpinnerService,
        private localStorage: LocalStorage
    ) {
        this.spinner.show();

        this.localStorage.getItem('user').subscribe(data => {
            this.sportService.getSports(data).subscribe(res => {
                this.sports = res;

                setTimeout(() => {
                    this.spinner.hide();
                }, 500);
            });
        });
    }

    ngOnInit() {}
}
